module.exports = __webpack_public_path__ + "img/NoviasYFiesta12.b9e83b87.jpg";